export default __webpack_public_path__ + "static/media/info_3.734e6f4e.png";